import * as React from 'react'
import { useStudioPathname } from '@repo/studio-config/studio-config-router'

import { useStudioLayoutResetView } from './use-studio-layout-reset-view'

/**
 * StudioLayout scrolls inside its content pane, not the window. The pane
 * persists across navigation, so its `scrollTop` lingers when a route swaps
 * content underneath — and a host router's own scroll reset only reaches the
 * window. Reset on every real pathname change so opening a detail page (or
 * returning to a grid) starts from the top; locale-only URL changes are
 * stripped by `useStudioPathname`, and hash navigations preserve position so
 * in-page anchors still land where they should.
 */
export function useScrollToTopOnNavigate() {
  const resetView = useStudioLayoutResetView()
  const pathname = useStudioPathname()

  React.useLayoutEffect(() => {
    if (window.location.hash) {
      return
    }

    resetView()
  }, [pathname, resetView])
}
